module.exports = __webpack_public_path__ + "img/wa.646ae9eb.png";